const state = {
    checkin: null,
    popupViewed: localStorage.getItem('popupViewed') ? JSON.parse(localStorage.getItem('popupViewed')) : {welcome: [], fixed: []}
}

export const getters = {
    eventBanner: state => state.checkin ? state.checkin.pica_service.banner : null,
    eventPopup: state => state.checkin ? state.checkin.pica_service.popup : {welcome: {active: false}, fixed: {active: false}},
    isPopupViewed: state => (type, picaServiceId) => state.popupViewed[type].includes(picaServiceId),
    checkin: state => state.checkin,
    picaServiceId: state => state.checkin ? state.checkin.pica_service.id : null,
    isPromo: state => state.checkin ? state.checkin.is_promocode || state.checkin.pica_service.is_promo : false,
    eventClosed: state => state.checkin ? state.checkin.pica_service.is_tagging_completed : false,
    hasBuyablePhotos: state => state.checkin ? state.checkin.has_buyable_photos : false,
    hasBuyableVideos: state => state.checkin ? state.checkin.has_buyable_videos : false,
    hasMediaOriginals: state => state.checkin ? state.checkin.pica_service.has_media_original : false,
    shareMode: state => state.checkin ? state.checkin.pica_service.share_mode : null,
    priceList: state => state.checkin ? state.checkin.price_list : null,
    eventName: state => state.checkin ? state.checkin.pica_service.event_name : '',
    picaCode: state => state.checkin ? state.checkin.picacode : '',
    hasBought: state => state.checkin ? state.checkin.has_bought_photos || state.checkin.has_bought_videos : false,
    boughtCount: state => state.checkin ? state.checkin.bought_photos_count + state.checkin.bought_videos_count: 0,
    canBuy: state => state.checkin ? state.checkin.price_list && state.checkin.price_list.items.findIndex(i => i.price > 0) !== -1 : false,
    shareWithFriends: state => state.checkin ? state.checkin.pica_service.share_with_friends : null,
    useGetPicaForYourEvent: state => state.checkin ? state.checkin.pica_service.get_pica_for_your_event : null,
    hdAvailableFrom: state => state.checkin ? state.checkin.pica_service.hd_available_from : null,
    hdAvailableTo: state => state.checkin ? state.checkin.pica_service.hd_available_to : null,
    canPurchaseDuringStay: state => state.checkin ? state.checkin.can_purchase_during_stay : null,
    currency: state => state.checkin ? state.checkin.pica_service.currency : null,
    videoOnlySale: state => state.checkin ?  state.checkin.price_list && state.checkin.price_list.videos_only_sale : false,
    showAllEventPhotos: state => state.checkin ? state.checkin.show_all_event_photos : null,
}


export const mutations = {
    set_checkin(state, checkin) {
        state.checkin = checkin
    },
    set_popup_viewed(state, {type, picaServiceId}) {
        state.popupViewed[type].push(picaServiceId)
        localStorage.setItem('popupViewed', JSON.stringify(state.popupViewed))
    },
    unset_event_popup(state) {
        state.checkin.pica_service.popup = {welcome: {active: false}, fixed: {active: false}}
    },
    clean_popup_viewed(state) {
        state.popupViewed = {welcome: [], fixed: []}
        localStorage.removeItem('popupViewed')
    }
}

export const actions = (eventService) => ({
    async fetchCheckin({commit}, picacode) {
        const response = await eventService.getCheckinDetail(picacode)
        commit('set_checkin', response.data)
    },
    setPopupViewed({commit}, {type, picaServiceId}) {
        commit('set_popup_viewed', {type, picaServiceId})
    },
    unsetEventPopup({commit}) {
        commit('unset_event_popup')
    },
})

export default eventService => ({
    namespaced: true,
    state,
    getters,
    mutations,
    actions: actions(eventService)
})
